import Header from "./Header";
import Accordion from "@mui/material/Accordion";
import { AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import Ourservices from "./Ourservices";
import Footerbrand from "./Footerbrand";
import Breadcrumb from "./Breadcrumb";

const Aboutus = () => {
  const [happyClients, setHappyClients] = useState(0);
  const [activeMembers, setActiveMembers] = useState(0);
  const [branches, setBranches] = useState(0);
  const [yearsOfExp, setYearsOfExp] = useState(0);

  useEffect(() => {
    const animate = (setValue, target, increment, duration) => {
      let current = 0;
      const totalSteps = Math.ceil(target / increment);
      const stepTime = duration / totalSteps;

      const updateValue = () => {
        if (current < target) {
          current += increment;
          setValue(Math.min(current, target));
          setTimeout(updateValue, stepTime);
        }
      };

      updateValue();
    };

    const totalDuration = 3000;
    animate(setHappyClients, 2000, 1000, totalDuration);
    animate(setActiveMembers, 750, 50, totalDuration);
    animate(setBranches, 12, 1, totalDuration);
    animate(setYearsOfExp, 3, 1, totalDuration);
  }, []);

  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="bg-gray">
      <Header name="About-us" />

      <section className="py-3 pt-4 section-background">
        <div className="container">
          <Breadcrumb
            title="About"
            highlight="Us"
            paths={[
              { name: "Home", link: "/Home" },
              { name: "About Us", link: null }
            ]}
          />
        </div>
      </section>

      <Ourservices />

      <section className="py-4 py-md-5">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-6 col-md-6 col-12 align-self-center pb-md-0 pb-4">
              <h5>Our Vision</h5>
              <h4 className="mb-20 text-dark fw-semibold">
                Simplifying complex businesses
              </h4>
              <p className="mb-20">
                Design isn't simply aesthetics. It's giving form to ideas,
                translating complex thoughts into visual clarity that moves
                hearts and minds. It's thinking, made visible.
              </p>
              <div className="mt-20">
                <a
                  href="https://api.whatsapp.com/send?phone=+919925615191&amp;text=Hi+9R NFC,+I+want+some+more+information+about+your+services.+Please+reply+soon."
                  className="btn-main-whatsApp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="d-flex align-items-center">
                    <i className="lni lni-whatsapp me-2"></i>Chat on WhatsApp
                  </span>
                </a>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="row">
                <div className="col-md-6 col-6 mb-4 text-center">
                  <h4 className="font-weight-normal mb-3">
                    <span className="statustxt1">
                      {(happyClients / 1000).toLocaleString()}K+
                    </span>
                  </h4>
                  <p className="font-weight-normal">
                    Custom NFC Cards Designed
                  </p>
                </div>
                <div className="col-md-6 col-6 mb-4 text-center">
                  <h4 className="font-weight-normal mb-3">
                    <span className="statustxt1">
                      {activeMembers.toLocaleString()}+
                    </span>
                  </h4>
                  <p className="font-weight-normal">
                    Products Successfully Delivered
                  </p>
                </div>
                <div className="col-md-6 col-6 mb-4 text-center">
                  <h4 className="font-weight-normal mb-3">
                    <span className="statustxt1">
                      {branches.toLocaleString()}+
                    </span>
                  </h4>
                  <p className="font-weight-normal">Experts on Our Team</p>
                </div>
                <div className="col-md-6 col-6 mb-4 text-center">
                  <h4 className="font-weight-normal mb-3">
                    <span className="statustxt1">
                      {yearsOfExp.toLocaleString()}+
                    </span>
                  </h4>
                  <p className="font-weight-normal">
                    Years of Smart Experience
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-35 pb-35 px-3 px-md-0 bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 p-0">
              <h4 className="justify-content-center mb-20 align-items-center d-flex">
                <i className="lni lni-question-circle text-dark" />
                <span className="ps-3 text-dark fw-semibold">
                  FAQs for Business
                </span>
              </h4>
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
                className="accordionAbout"
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  className="accordionHeading"
                >
                  <Typography>
                    How do I make a digital business card?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className="accordionTxt">
                    It’s simple? You just need to get in touch with the experts
                    at Touch Cards so that you can avail yourself of the ages of
                    experience that we have earned. Right from Business Card
                    Design to Business Card Printing, we offer you complete
                    technical expertise to get you the best digital business
                    cards.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
                className="accordionAbout"
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  className="accordionHeading"
                >
                  <Typography>Which digital business card is best?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className="accordionTxt">
                    The answer can be slightly technical. It depends on various
                    things that vary from one user to another. At Touch Cards,
                    our experts recommend you get in touch with them online or
                    offline and get the right information before you decide
                    which cards can serve you the most aptly.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel3"}
                onChange={handleChange("panel3")}
                className="accordionAbout"
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                  className="accordionHeading"
                >
                  <Typography>Are digital business cards worth it?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className="accordionTxt">
                    Certainly Yes! The utilities of Digital Name Cards in
                    Singapore have increased their demands all over. You can
                    always prefer getting one to ease your communication with
                    your clients/patrons.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel4"}
                onChange={handleChange("panel4")}
                className="accordionAbout"
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4bh-content"
                  id="panel4bh-header"
                  className="accordionHeading"
                >
                  <Typography>
                    Are digital business cards a good idea?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className="accordionTxt">
                    You may not have any doubt about them as far as their
                    utilities are concerned. These digital business cards assist
                    professionals to create the first impression for a
                    sustainable business relationship with their customers. You
                    can always get in touch with the experts at Touch Cards to
                    clear all the confusions that you may have in the most
                    unique manner.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel5"}
                onChange={handleChange("panel5")}
                className="accordionAbout"
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel5bh-content"
                  id="panel5bh-header"
                  className="accordionHeading"
                >
                  <Typography>
                    What is the need for digital business cards?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="accordionTxt">
                    <Typography>
                      Well, many customers ask these questions from us when they
                      reach us for the first time. We assure them of the
                      following advantages that make these cards an absolute
                      necessity:
                    </Typography>
                    <ul className="custom-list">
                      <li>Card Customization</li>
                      <li>SEO-Friendly Features</li>
                      <li>Card Redirection Facility</li>
                    </ul>

                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </div>
      </section>
      <Footerbrand />
      <Footer />
    </div>
  );
};

export default Aboutus;
